import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F1065SchCService {
  constructor(private http: HttpClient) {}

  /**
   * Load pivot form JSON data (SuperPrompt V9)
   */
  loadPivotFormJson(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadPivotFormJson`;

    // Merge with global params
    const mergedParams = { ...globalService?.globalParams, ...params };

    // CRITICAL: Use GET method, not POST (SuperPrompt V9)
    return this.http.get<any>(url, { 
      params: mergedParams,
      withCredentials: true 
    });
  }

  /**
   * Save Schedule C Form (SuperPrompt V9)
   */
  saveScheduleCForm(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    processName: string = '1065 Textual Information'
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=tkgaam`;

    // Build jsonSettings (EXACT match to AngularJS)
    const jsonSettings = {
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO_KEY,
      jcd_key: rowData.JCD_KEY,
      combination_key: rowData.COMBINATION_KEY,
      trans_type_key: formData[0].editrows[0][0].trans_type_key
    };

    // CRITICAL: filterParams already contains checkLockedbj, scenarioCode, is_issue_key_enabled, parent_me_string
    // from workspaceFactory.activeScreen.filters.getFilterParams() - DO NOT add checkLockedbj manually!
    
    // Merge globalParams with filterParams (filterParams overrides globalParams if same keys)
    const mergedParams = { ...globalService?.globalParams, ...filterParams };

    // CRITICAL: Build payload in EXACT order as AngularJS (SuperPrompt V9)
    // MUST build manually as string array to guarantee order!
    const payloadParts: string[] = [];
    
    // Helper to encode parameter
    const encode = (key: string, value: any) => {
      if (value === null || value === undefined) {
        return `${encodeURIComponent(key)}=`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    };
    
    // 1. FIRST: jsonSettings and jsonObj (MANDATORY ORDER per AngularJS _.extend)
    payloadParts.push(encode('jsonSettings', JSON.stringify(jsonSettings)));
    payloadParts.push(encode('jsonObj', JSON.stringify(formData)));
    
    // 2. THEN: Add all mergedParams (globalParams + filterParams) in their order
    // This includes: tax_year, screen_key, scenario, jcd_key, jcd_ta_key, activity_key, 
    // screen_type, is_locked, issue_id, issue_short_desc, issue_id_for_tx_save,
    // checkLockedbj, scenarioCode, is_issue_key_enabled, parent_me_string
    Object.keys(mergedParams).forEach(key => {
      const value = mergedParams[key];
      if (typeof value === 'object' && value !== null) {
        payloadParts.push(encode(key, JSON.stringify(value)));
      } else if (value !== undefined) {
        payloadParts.push(encode(key, value?.toString() || ''));
      }
    });
    
    // 3. FINALLY: Add ONLY the params that AngularJS adds at the very end
    payloadParts.push(encode('process_name', processName));
    payloadParts.push(encode('combination_key', rowData.COMBINATION_KEY.toString()));
    payloadParts.push(encode('trans_type_key', formData[0].editrows[0][0].trans_type_key.toString()));

    // Join all parts with &
    const payloadString = payloadParts.join('&');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    // CRITICAL: withCredentials must be true (SuperPrompt V9)
    return this.http.post<any>(url, payloadString, { 
      headers, 
      withCredentials: true 
    });
  }
}

